import React from "react";
import PoupancaAcumulada from "~/images/poupanca_acumulada.svg?react";
import PoupancaAcumulada2 from "~/images/poupanca_acumulada2.svg?react";

const DEFAULT_TIP_TITLE = "Aproveite os ciclos horários da sua tarifa";
const DEFAULT_TIP_TEXT =
  "Se tiver uma tarifa bi ou tri-horária, prefira os períodos em vazio para utilizar eletrodomésticos de elevado consumo como máquinas de lavar/secar, bomba da piscina ou termoacumulador/bomba de calor para aquecimento de águas sanitárias.";

const DeviseLayout = ({
  children,
  tipTitle = DEFAULT_TIP_TITLE,
  tipText = DEFAULT_TIP_TEXT,
  rightPanelClassName = "flex flex-col justify-center p-10",
}) => {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-sidebar-bg p-4 md:p-8 lg:p-10 overflow-hidden">
      <div className="bg-white rounded-3xl shadow-xl lg:w-4/5 w-full max-h-full h-full grid lg:grid-rows-1 lg:grid-cols-2 overflow-hidden">
        <div className="flex flex-col items-center justify-center bg-gradient-to-b from-btn-primary to-btn-tertiary text-white p-4 lg:p-8 gap-2 lg:gap-6 text-center overflow-hidden">
          <div className="lg:hidden flex flex-col items-center gap-1">
            <PoupancaAcumulada className="w-1/4 h-auto" />
            <h2 className="text-3xl font-semibold">Dicas Eficientes</h2>
            <h3 className="text-base font-medium opacity-90 line-clamp-2">
              {tipTitle}
            </h3>
          </div>

          <div className="hidden lg:flex flex-col items-center gap-8">
            <h2 className="text-6xl font-semibold mb-2">Dicas Eficientes</h2>
            <h3 className="text-3xl font-medium mb-4">{tipTitle}</h3>
            <PoupancaAcumulada2 className="w-64 xl:w-80 h-auto" />
            <p className="text-lg xl:text-xl leading-relaxed max-w-lg">
              {tipText}
            </p>
          </div>
        </div>

        <div className={rightPanelClassName}>{children}</div>
      </div>
    </div>
  );
};

export default DeviseLayout;
